/**
 * Every pricing card works against one of the fence pricing stores - the configurator's or HUB's
 * own - which share their shape (see stores/modules/fence-pricing-module.js). The container passes
 * the module name down as `namespace`, so the cards never name a store themselves.
 */
export default {
	props: {
		namespace: {
			type: String,
			required: true
		}
	},
	computed: {
		section() {
			return this.$store.state[this.namespace];
		}
	},
	methods: {
		dispatchSection(action, payload) {
			return this.$store.dispatch(this.namespace + "/" + action, payload);
		}
	}
};
